import comp from "./CheckboxGroup";
export default comp;
